import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "product-price-details" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "product-price-details" }
const _hoisted_5 = { class: "fs-regular" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "product-price-details" }
const _hoisted_10 = { class: "text-small" }
const _hoisted_11 = ["href"]

import {
  PropType,
  computed,
} from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faInfoCircle, faDownload } from '@fortawesome/pro-light-svg-icons';
import { Product } from '@/classes';
import { env, formatNumber, getNumberPrecision } from '@/helpers';
import BaseTabs from '@/components/BaseTabs.vue';
import BaseTabsTab from '@/components/BaseTabsTab.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceDetailsTable',
  props: {
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
},
  setup(__props) {

library.add(faInfoCircle);
library.add(faDownload);

const props = __props;

const rowsConditions = computed(() => {
  let rows: Array<Array<string | number | null | undefined>> = [];

  rows = [
    ...rows,
    ...[
      ['Vertragslaufzeit', `${props.product.contractTermLabel},<br><span class="small--text">danach monatlich kündbar</span>`],
      [
        'Preisfixierung²',
        props.product.attributes.deactivatePriceGuaranteeLabel
          ? '-'
          : `${props.product.priceGuaranteeLabel}`,
      ],
    ],
  ];

  return rows;
});

const rowsPrices = computed(() => {
  let rows: Array<Array<string | number | null | undefined>> = [];

  if (props.product.priceIsDouble) {
    rows = [...rows, ...[
      ['Preis pro kWh HT', `${props.product.getPriceFormatted('workingPriceHt')}&thinsp;Cent&nbsp;`],
      ['Preis pro kWh NT', `${props.product.getPriceFormatted('workingPriceNt')}&thinsp;Cent&nbsp;`],
    ]];
  } else {
    if (props.product?.attributes.details.contractDetails.savingCalculation === 'beforeBonus') {
      rows.push(['Kosten pro Jahr', `${formatNumber(props.product.price?.mapped.active.yearlyGross, 2)}&thinsp;€`]);
    } else {
      rows.push(['Kosten pro Jahr', `${props.product.getPriceFormatted('yearly')}&thinsp;€`]);
    }
    rows.push(['Arbeitspreis brutto', `${props.product.getPriceFormatted('workingPrice')}&thinsp;Cent / kWh`]);
    if (props.product?.price?.mapped.active.warrantyWorkingPrice) {
      rows.push(['Arbeitspreis ohne Steuern und Abgaben²', `${formatNumber(props.product?.price?.mapped.active.warrantyWorkingPrice * 100, 2)}&thinsp;Cent / kWh`]);
    }
  }

  if (props.product.category.key === 'gas' && env('GAS_STORAGE_SURCHARGE')) {
    const gasStorageSurcharge = env('GAS_STORAGE_SURCHARGE', 0) as number;
    rows.push(['exkl. Gasspeicherumlage<br>(§ 35 e EnWG)', `${formatNumber(gasStorageSurcharge, getNumberPrecision(gasStorageSurcharge))}&thinsp;ct/kWh`]);
  }

  rows = [...rows, ...[
    ['Grundpreis brutto', `${props.product.getPriceFormatted('basePrice')}&thinsp;€ / Monat`],
  ]];

  if (props.product.category.key === 'power' && props.product?.price?.mapped.active.warrantyBasePrice) {
    rows.push(['Grundpreis netto ohne Messstellenbetrieb²', `${formatNumber(props.product?.price?.mapped.active.warrantyBasePrice, 2)}&thinsp;€ / Monat`]);
  }

  return rows;
});

const rowsDownloads = computed(() => {
  const rows: Array<{
    key: string;
    label: string;
    href: string;
    downloadName?: string;
  }> = [];

  if (props.product.priceFileUrl) {
    rows.push({
      key: 'pricefile',
      label: 'Preisblatt',
      href: props.product.priceFileUrl,
      downloadName: `Preisblatt ${props.product.name} ${props.product.price?.params.postcode}`,
    });
  }

  const agbDocument = props.product.getDocumentByKey('agb');
  if (props.product.hasDocument('agb') && agbDocument) {
    rows.push({
      key: agbDocument.key,
      label: agbDocument.name || '',
      href: agbDocument.url || '#',
    });
  }

  const avbDocument = props.product.getDocumentByKey('avb');
  if (props.product.hasDocument('avb') && avbDocument) {
    rows.push({
      key: avbDocument.key,
      label: avbDocument.name || '',
      href: avbDocument.url || '#',
    });
  }

  const bgbDocument = props.product.getDocumentByKey('bgb');
  if (props.product.getDocumentByKey('bgb') && bgbDocument) {
    rows.push({
      key: bgbDocument.key,
      label: bgbDocument.name || '',
      href: bgbDocument.url || '#',
    });
  }

  props.product.getDocumentsExcept(['agb', 'avb', 'bgb']).forEach((doc) => {
    rows.push({
      key: doc.key,
      label: doc.name || '',
      href: doc.url || '#',
    });
  });

  return rows;
});

return (_ctx: any,_cache: any) => {
  const _component_IoTooltip = _resolveComponent("IoTooltip")!

  return (_openBlock(), _createBlock(BaseTabs, null, {
    default: _withCtx(() => [
      _createVNode(BaseTabsTab, { title: "Vertragskonditionen" }, {
        default: _withCtx(() => [
          _createElementVNode("table", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowsConditions.value, (row) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: row[0]
              }, [
                _createElementVNode("td", {
                  class: "fs-regular",
                  innerHTML: row[0]
                }, null, 8, _hoisted_2),
                _createElementVNode("td", {
                  class: "fs-regular",
                  innerHTML: row[1]
                }, null, 8, _hoisted_3)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }),
      _createVNode(BaseTabsTab, { title: "Preise" }, {
        default: _withCtx(() => [
          _createElementVNode("table", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowsPrices.value, (row) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: row[0]
              }, [
                _createElementVNode("td", _hoisted_5, [
                  _createElementVNode("span", {
                    innerHTML: row[0]
                  }, null, 8, _hoisted_6),
                  _createElementVNode("sup", {
                    class: "d-none d-print-inline",
                    innerHTML: row[3]
                  }, null, 8, _hoisted_7),
                  (row[2])
                    ? (_openBlock(), _createBlock(_component_IoTooltip, {
                        key: 0,
                        class: "color-primary d-print-none"
                      }, {
                        title: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row[2]), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-info-circle" })
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", {
                  class: "fs-regular",
                  innerHTML: row[1]
                }, null, 8, _hoisted_8)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }),
      _createVNode(BaseTabsTab, { title: "Downloads" }, {
        default: _withCtx(() => [
          _createElementVNode("table", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowsDownloads.value, (row) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: row[0]
              }, [
                _createElementVNode("th", _hoisted_10, [
                  _createElementVNode("a", _mergeProps({
                    href: row['href'],
                    target: "_blank",
                    ref_for: true
                  }, row.downloadName ? { download: row.downloadName } : {}), [
                    _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-download" }),
                    _createTextVNode(" " + _toDisplayString(row['label']), 1)
                  ], 16, _hoisted_11)
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})